import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import { isPage } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();


  if (isPage('contact')) {
    new TopFormValidation({});
  }


  // ページ内スクロール
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();

      const speed = 600;
      const href = this.getAttribute("href");
      const target = document.querySelector(href === "#" || href === "" ? "html" : href);
      let position = target.getBoundingClientRect().top + window.pageYOffset - 120;

      if (window.matchMedia('(max-width:768px)').matches) {
        position = target.getBoundingClientRect().top + window.pageYOffset - 50;
      }

      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    });
  });


  const swiper = new Swiper(".swiper", {
    loop: true, // ループ有効
    slidesPerView: 2, // 一度に表示する枚数
    speed: 10000, // ループの時間
    allowTouchMove: true, // スワイプ有効
    autoplay: {
      delay: 0, // 途切れなくループ
    },
    breakpoints: {
      768: {
        slidesPerView: 3, // 一度に表示する枚数を1に変更
      }
    }
  });



  const menuBtn = document.querySelector('.hd_toggle');
  const menuContent = document.querySelector('.hd_block');

  menuBtn.addEventListener('click', function() {
    this.classList.toggle('is_active');

    if (this.classList.contains('is_active')) {
      menuContent.classList.add('is_active');
    } else {
      menuContent.classList.remove('is_active');
    }
  });


  const productLink = document.querySelector('.product_link');
  const productNav = document.querySelector('.product_nav');
  const breakpoint = 1250; // 特定の画面幅（例: 768px）

  productLink.addEventListener('click', function(event) {
    if (window.innerWidth <= breakpoint) {
      event.preventDefault();
      productNav.classList.toggle('is_active');
      productLink.classList.toggle('is_active');

      // アコーディオンの動作を追加
      if (productNav.classList.contains('is_active')) {
        productNav.style.maxHeight = productNav.scrollHeight + "px";
      } else {
        productNav.style.maxHeight = null;
      }
    }
  });

  window.addEventListener('resize', function() {
    if (window.innerWidth > breakpoint) {
      productNav.classList.remove('is_active');
      productLink.classList.remove('is_active');
      productNav.style.maxHeight = null;
    }
  });

  function BlurTextAnimeControl() {
    var elements = document.querySelectorAll('.blurTrigger'); // blurTriggerというクラス名の要素を全て取得
    var windowHeight = window.innerHeight; // ウィンドウの高さ

    elements.forEach(function(element) {
        var elemPos = element.getBoundingClientRect().top + window.pageYOffset - 50; // 要素の位置を取得
        var scroll = window.pageYOffset; // 現在のスクロール位置

        // 要素が画面内に入ったかどうかを判定
        if (scroll >= elemPos - windowHeight) {
            element.classList.add('blur'); // 画面内に入ったらblurというクラス名を追記
        } else {
            element.classList.remove('blur'); // 画面外に出たらblurというクラス名を外す
        }
    });
  }

  // 画面をスクロールしたら動かしたい場合の記述
  window.addEventListener('scroll', function() {
      BlurTextAnimeControl(); // アニメーション用の関数を呼ぶ
  });

  // 画面が読み込まれたらすぐに動かしたい場合の記述
  window.addEventListener('load', function() {
      BlurTextAnimeControl(); // アニメーション用の関数を呼ぶ
  });


  window.addEventListener('load', function() {
    // クラスが 'has-select' の全ての要素を取得
    const elements = document.querySelectorAll('.has-select');

    // 取得した全ての要素に対して処理を行う
    elements.forEach((element) => {
      // 要素のテキストが「都道府県」の場合
      if (element.textContent.trim() === '都道府県') {
        // 要素のテキストを空にする
        element.textContent = '';
      }
    });
  });

  //group-fadeIn animation
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  const fadeinGroups = document.querySelectorAll('.fadein-group');

  function checkPosition() {
    const windowHeight = window.innerHeight;
    const scroll = window.scrollY;

    fadeinGroups.forEach(group => {
      const position = group.getBoundingClientRect().top + scroll;

      if (scroll > position - windowHeight + 200) {
        const fadeinElements = group.querySelectorAll('.fadein');
        fadeinElements.forEach((element, index) => {
          setTimeout(() => {
            element.classList.add('active');
          }, index * 200);
        });
      }
    });
  }

  window.addEventListener('scroll', debounce(checkPosition, 100));
  checkPosition(); // 初回チェックを行うために実行

});
